import ChapterDisplay from './ChapterDisplay';
import Comments from './Comments';

export default function Capitulo2() {
    const section = 'casa-de-la-abuela';
    const title = 'Casa de la abuela';
    const description = '¡Al fin soy parte de la tradición famliar!';
    const text = '<p><b>Hoy fue muy chido llegar a la casa de mi abuela Paz.</b> Aunque ya no está, todavía se siente su energía y huele a sus tortillas. Me encontré con mis primos Kairo y Kalid, que son súper simpáticos.</p><p>Aquí en Tzintzuntzan todos se andan preparando para la Noche de Muertos. Es bien diferente a la Ciudad de México. Mi mamá me pidió que le ayudara a cocinar las ofrendas, ¡y yo me sentí bien especial! Mientras hacía uchepos, sentí que mi abuelita estaba ahí conmigo, ¡y eso me hizo sentir muy feliz!</p><p><b>Los uchepos</b> son como tamalitos dulces de maíz fresco que huelen y saben a cielo. Se hacen con elote nuevo molido, leche y a veces un poquito de azúcar, y se cocen envueltos en las hojas verdes de la misma mazorca, ¡quedan supersuavecitos! A mi familia y a mí nos encanta comerlos con crema, queso cotija y una salsita verde. Para mí, los uchepos saben a fiesta y a tradición, porque solo se preparan cuando el maíz está tierno. Me enseñan que los ingredientes más simples, como el maíz, son un tesoro que nos da la tierra y que compartir un platillo tan especial en familia hace que cualquier día sea más feliz.</p><p>Pero de la nada, escuché un ruido bien raro, como de cadenas y murciélagos. Fue tan fuerte que me asusté. No sé qué signifique, ¡pero creo que algo grande está pasando!</p>';
    const image = 'https://www.diadelavida.com/images/chapters/deco_capitulo2.png?v='+Date.now();
    const image_number = 'https://www.diadelavida.com/images/numbers/2.png'
    const image_size = 'contain';
    const image_position = 'center';
    const image_height = 400;
    const comments_prompt = '¿Qué te pareció este capítulo? ¿Te gustan los uchepos? ¡Deja tu comentario!';

    const images = [
        {
            id: 1,
            src: 'https://www.diadelavida.com/images/chapters/capitulo2_main.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 2',
            description: '¿Cómo que no hay internet en Tzintzuntzan? ¡¿Cómo voy a subir mis fotos?!'
        },
        {
            id: 2,
            src: 'https://diadelavida.com/images/cards/card_kairokalid_01.jpg?',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 2',
            description: 'Mis primos Kairo y Kalid son bien simpáticos y me hacen reír un montón.'
        }
    ];

    return (
        <div>
            <ChapterDisplay
                section={section}
                title={title}
                description={description}
                text={text}
                image={image}
                imageSize={image_size}
                imagePosition={image_position}
                imageHeight={image_height}
                images={images}
                imageNumber={image_number}
            />
            <div id='users-comments'>
                <div className="comments-deco"></div>
                <div className="container">
                    <div className="row">
                        <Comments sectionId={section} commentsPrompt={comments_prompt} />
                    </div>
                </div>
            </div>
        </div>
    );
}